import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class SurveyPopup extends React.PureComponent {
    static propTypes = {
        handleClosePopup: PropTypes.func,
        handleCallupFn: PropTypes.func,
        callAppConfig: PropTypes.object,
    };

    componentDidMount() {
        document.body.style.overflow = 'hidden';
    }

    handleClickShadow = (event) => {
        if (event?.target?.getAttribute?.('id') === 'surveyPopup') {
            this.props.handleClosePopup();
        }
    };

    render() {
        const { handleClosePopup, handleCallupFn, callAppConfig } = this.props;

        return (
            <div className={styles.surveyPopup} onClick={this.handleClickShadow} id="surveyPopup">
                <div className={styles.surveyPopupBox} onClick={this.handleClickContent}>
                    <div className={styles.headBox}>
                        <div className={styles.head}>
                            <div className={styles.close} onClick={handleClosePopup} />
                            <div className={styles.title}>凤凰小调查</div>
                            <div className={styles.callAppBox} onClick={handleCallupFn}>
                                {callAppConfig && (
                                    <div className={styles.callApp} onClick={handleCallupFn}>
                                        打开app
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default SurveyPopup;
